import styled from 'styled-components';
import { Loader, Text, Box, Title, VerticalBox } from '../../components';
import { useQuery } from '@tanstack/react-query';
import { fetchAboutUsPageContent } from '../../services/about-us/fetchAboutUsPageContent';
import { COLORS, device, FONTS } from '../../constants';
import { Description } from './partials/Description/Description';
import { AboutUsTeam } from './partials/Team/AboutUsTeam';
import { TeamDeliverables } from './partials/TeamDeliverables/TeamDeliverables';
import { AboutUsProvide } from './partials/Provide/AboutUsProvide';
import { AboutUsContact } from './partials/Contact/AboutUsContact';
import { MotionAboutUsHeaderLogo, MotionSecondaryHeaderBackground, MotionText } from '../../components/Motion';
import { Logo } from '../../assets/png';

export const AboutUs = () => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['about_us'],
    queryFn: fetchAboutUsPageContent,
  });
  if (isLoading || !data) return <Loader />;
  if (error) return <Text text="Error..." />;
  return (
    <>
      <AboutUsHeader>
        <Box>
          <VerticalBox>
            <AboutUsHeaderContent>
              <AboutUsHeaderWrapper>
                <Title
                  color={COLORS.HEADER_TEXT_COLOR}
                  title={data.aboutUsHeader.Title}
                  size={60}
                  lineHeight={70}
                  weight={600}
                />
                <AboutUsHeaderPoints>
                  {data.aboutUsHeader.Points.map((point, index) => (
                    <li key={index}>
                      <Text
                        text={point}
                        fontFamily={FONTS.SUBTITLE}
                        size={22}
                        lineHeight={28}
                        color={COLORS.HEADER_TEXT_COLOR}
                      />
                    </li>
                  ))}
                </AboutUsHeaderPoints>
              </AboutUsHeaderWrapper>
              <PortfolioLogoWrapper>
                <img src={Logo} alt='Logo' />
              </PortfolioLogoWrapper>
            </AboutUsHeaderContent>
          </VerticalBox>
        </Box>
      </AboutUsHeader>
      <Description description={data.description} />
      <AboutUsTeam team={data.team} />
      <TeamDeliverables teamDeliverables={data.teamDeliverables} />
      <AboutUsProvide provide={data.aboutUsProvide} />
      <AboutUsContact data={data.aboutUsContact} />
    </>
  );
};

const AboutUsHeader = styled(MotionSecondaryHeaderBackground)``;

const AboutUsHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (${device.md}) {
    gap: 50px;
  }
  @media screen and (${device.sm}) {
    gap: 10px;
  }
`;

const AboutUsHeaderWrapper = styled(MotionText)`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 60%;
  @media screen and (${device.lg}) {
    span {
      font-size: 50px;
      line-height: 60px;
    }
  }
  @media screen and (${device.md}) {
    gap: 20px;
    max-width: none;
    span {
      font-size: 33px;
      line-height: 40px;
    }

    h4 {
      font-size: 18px;
      line-height: 24px;
    }
  }
  @media screen and (${device.sm}) {
    gap: 10px;
    span {
      font-size: 18px;
      line-height: 27px;
    }
    h4 {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;

const AboutUsHeaderPoints = styled.ul`
  padding-left: 15px;
  color: ${COLORS.MAIN_RED};
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const PortfolioLogoWrapper = styled(MotionAboutUsHeaderLogo)`
  width: 243px;
  height: 243px;
  border-radius: 50%;
  border: 2px dashed ${COLORS.ACTIVE_ITEM};
  display: flex;
  align-items: center;
  flex: 0 0 auto;

  img {
    width: 250px;
    position: relative;
    top: -15px;
  }

  @media screen and (${device.lg}) {
    width: 200px;
    height: 200px;

    img {
      width: 100%;
      top: -5px;
    }
  }
  @media screen and (${device.bsm}) {
    width: 120px;
    height: 120px;
  }
`;
